import React from "react";
import { Search } from "lucide-react";

import styles from "./SearchInput.module.css";

export const SearchInput = ({
  value = "",
  onChange,
  placeholder = "Search",
  disabled,
  filterIcon,
  variant = "toolbar",
  className,
  ...inputProps
}) => {
  const wrapperClass = [
    styles.searchWrapper,
    variant === "standalone" && styles.standalone,
    variant === "bordered" && styles.bordered,
    filterIcon && styles.hasFilterIcon,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClass}>
      <Search size={20} className={styles.searchIcon} aria-hidden />
      <input
        type="search"
        className={styles.searchInput}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        disabled={disabled}
        {...inputProps}
      />
      {filterIcon && <div className={styles.filterIcon}>{filterIcon}</div>}
    </div>
  );
};
